const { registerBlockType } = wp.blocks;
const { PanelBody, RangeControl, SelectControl } = wp.components;
const { InspectorControls, RichText, URLInputButton } = wp.blockEditor;
const { useEffect, useState } = wp.element;
const { apiFetch } = wp;
const { useSelect } = wp.data;

import Select from 'react-select';

registerBlockType('pg/insights', {
  title: 'PG Latest Insights',
  icon: 'megaphone',
  category: 'widgets',
  attributes: {
    headingText: {
      type: 'string',
      default: 'Insights',
    },
    seeMoreUrl: {
      type: 'string',
      default: '',
    },
    seeMoreText: {
      type: 'string',
      default: 'See more',
    },
    numberOfPosts: {
      type: 'number',
      default: 3,
    },
    selectedCategories: {
      type: 'array',
      default: [],
    },
    selectedTags: {
      type: 'array',
      default: [],
    },
    sectionClass: {
      type: 'string',
      default: 'section-light-primary',
    },
    cornerPositionClass: {
      type: 'string',
      default: 'corner-left-top',
    },
    cornerBackgroundClass: {
      type: 'string',
      default: 'corner-on-dark-secondary',
    },
  },

  edit: ({ attributes, setAttributes, isSelected }) => {
    const { numberOfPosts, selectedCategories, selectedTags } = attributes;
    const [latestPosts, setLatestPosts] = useState([]);
    const [categories, setCategories] = useState([]);
    const [tags, setTags] = useState([]);

    console.log(selectedCategories, selectedTags);

    const currentPostId = useSelect(
      (select) => select('core/editor').getCurrentPostId(),
      []
    );
    const currentPostLanguage = useSelect(
      (select) =>
        select('polylang')?.getPostLanguage(currentPostId)?.slug || 'en',
      [currentPostId]
    );

    useEffect(() => {
      // Fetch categories
      apiFetch({ path: '/wp/v2/categories?per_page=100' }).then((data) => {
        setCategories(data.map((cat) => ({ value: cat.id, label: cat.name })));
      });

      // Fetch tags
      apiFetch({ path: '/wp/v2/tags?per_page=100' }).then((data) => {
        setTags(data.map((tag) => ({ value: tag.id, label: tag.name })));
      });
    }, []);

    useEffect(() => {
      // Fetch posts based on selected filters
      let query = `/wp/v2/posts?per_page=${numberOfPosts}&_embed`;

      if (selectedCategories.length) {
        query += `&categories=${selectedCategories.map((cat) => cat.value).join(',')}`;
      }
      if (selectedTags.length) {
        query += `&tags=${selectedTags.map((tag) => tag.value).join(',')}`;
      }

      apiFetch({ path: query }).then((posts) => {
        setLatestPosts(posts);
      });
    }, [numberOfPosts, selectedCategories, selectedTags]);

    const btnClass =
      attributes.sectionClass && attributes.sectionClass.includes('dark')
        ? 'btn-light'
        : 'btn-dark';

    return (
      <div>
        {isSelected && (
          <InspectorControls>
            <PanelBody title="Settings">
              <SelectControl
                label="Section Class"
                value={attributes.sectionClass}
                options={[
                  { label: 'Dark Primary', value: 'section-dark-primary' },
                  { label: 'Dark Secondary', value: 'section-dark-secondary' },
                  { label: 'Light Primary', value: 'section-light-primary' },
                  {
                    label: 'Light Secondary',
                    value: 'section-light-secondary',
                  },
                ]}
                onChange={(value) => setAttributes({ sectionClass: value })}
              />

              <SelectControl
                label="Corner Position"
                value={attributes.cornerPositionClass}
                options={[
                  { label: 'None', value: 'corner-disabled' },
                  { label: 'Left Top', value: 'corner-left-top' },
                  { label: 'Left Bottom', value: 'corner-left-bottom' },
                  { label: 'Right Top', value: 'corner-right-top' },
                  { label: 'Right Bottom', value: 'corner-right-bottom' },
                ]}
                onChange={(value) =>
                  setAttributes({ cornerPositionClass: value })
                }
              />

              <SelectControl
                label="Corner Background"
                value={attributes.cornerBackgroundClass}
                options={[
                  { label: 'Dark Primary', value: 'corner-on-dark-primary' },
                  {
                    label: 'Dark Secondary',
                    value: 'corner-on-dark-secondary',
                  },
                  { label: 'Light Primary', value: 'corner-on-light-primary' },
                  {
                    label: 'Light Secondary',
                    value: 'corner-on-light-secondary',
                  },
                ]}
                onChange={(value) =>
                  setAttributes({ cornerBackgroundClass: value })
                }
              />

              <RangeControl
                label="Number of Insights"
                value={attributes.numberOfPosts}
                onChange={(newCount) =>
                  setAttributes({ numberOfPosts: newCount })
                }
                min={1}
                max={10}
              />
              <label>Categories</label>
              <Select
                isMulti
                options={categories}
                value={selectedCategories}
                onChange={(selected) =>
                  setAttributes({ selectedCategories: selected })
                }
              />

              <label>Tags</label>
              <Select
                isMulti
                options={tags}
                value={selectedTags}
                onChange={(selected) =>
                  setAttributes({ selectedTags: selected })
                }
              />
            </PanelBody>
          </InspectorControls>
        )}
        <section className={attributes.sectionClass}>
          <div
            className={`corner ${attributes.cornerPositionClass} ${attributes.sectionClass.replace('section', 'corner')} ${attributes.cornerBackgroundClass}`}
          ></div>
          <div className="insights-wrapper">
            <div className="top">
              <RichText
                tagName="h2"
                value={attributes.headingText}
                onChange={(newText) => setAttributes({ headingText: newText })}
                placeholder="Enter heading..."
              />
              <a
                href={'#'}
                className={`btn ${btnClass} btn-outline`}
                title={attributes.seeMoreUrl}
              >
                <RichText
                  tagName="span"
                  value={attributes.seeMoreText}
                  onChange={(newSeeMoreText) =>
                    setAttributes({ seeMoreText: newSeeMoreText })
                  }
                />
                <URLInputButton
                  url={attributes.seeMoreUrl}
                  onChange={(newUrl) => setAttributes({ seeMoreUrl: newUrl })}
                />
              </a>
            </div>
            <div className="columns-wrapper">
              {latestPosts.length ? (
                latestPosts.map((post) => {
                  const featuredImage =
                    post._embedded &&
                    post._embedded['wp:featuredmedia'] &&
                    post._embedded['wp:featuredmedia'][0] &&
                    post._embedded['wp:featuredmedia'][0].source_url;
                  const postDate = new Date(post.date).toLocaleString(
                    'default',
                    {
                      month: 'long',
                      year: 'numeric',
                    }
                  );

                  return (
                    <div key={post.id} className="column">
                      <div className={'image'}>
                        <img src={featuredImage} alt={post.title.rendered} />
                        <p>
                          <span>New</span>
                          <a
                            href={post.link}
                            className="btn btn-light btn-outline btn-icon btn-small"
                          ></a>
                        </p>
                      </div>
                      <h3
                        dangerouslySetInnerHTML={{
                          __html: post.title.rendered,
                        }}
                      />
                    </div>
                  );
                })
              ) : (
                <p>No more latest insights...</p>
              )}
            </div>
          </div>
        </section>
      </div>
    );
  },

  save: () => null,
});
